import { Outlet } from "react-router-dom";
import {
  NftApiApiKeysUrl,
  NftApiOverviewUrl,
  NftApiPlansUrl,
} from "../../utils/urls";
import { Helmet } from "react-helmet";
import NftApiApiKeysTab from "../../components/nft-api/api_keys/NftApiApiKeysTab";
import NftApiOverviewTab from "../../components/nft-api/oweview/MarketApiOverviewTab";
import NftApiPlansTab from "../../components/nft-api/plans/NftApiPlansTab";
import ComputerIcon from "./../../assets/icons/computer-desktop.svg?react";
import KeyIcon from "./../../assets/icons/key.svg?react";
import ListBulletIcon from "./../../assets/icons/list-bullet.svg?react";
import { Typography, Tabs, TabOptions } from "djuno-design";
import useServiceType from "../../hooks/useServiceType";

export const NftApiPageMenus: TabOptions = [
  {
    label: (
      <div className="flex items-center gap-1">
        <ComputerIcon className="w-3" />
        Overview
      </div>
    ),
    url: NftApiOverviewUrl,
    element: <NftApiOverviewTab />,
    testId: "1th-tab",
  },
  {
    label: (
      <div className="flex items-center gap-1">
        <KeyIcon className="w-3" />
        Access Keys
      </div>
    ),
    url: NftApiApiKeysUrl,
    element: <NftApiApiKeysTab />,
    testId: "2th-tab",
  },
  {
    label: (
      <div className="flex items-center gap-1">
        <ListBulletIcon className="w-3" />
        Plans
      </div>
    ),
    url: NftApiPlansUrl,
    element: <NftApiPlansTab />,
    testId: "3th-tab",
  },
];

const NftApiPage = () => {
  const { serviceType } = useServiceType(
    import.meta.env.VITE_NFT_API_SERVICE_TYPE
  );
  return (
    <>
      <Helmet>
        <title>
          {import.meta.env.VITE_APP_NAME} | {serviceType?.ServiceName || ""}
        </title>
        <meta name="description" content="" />
      </Helmet>
      <div className="flex items-center justify-between h-20">
        <div className="px-6 items-center justify-between flex flex-1 transition duration-150">
          <Typography.Title level={5} className="!mb-0">
            {serviceType?.ServiceName}
          </Typography.Title>
        </div>
        {/* <div className="mr-6 w-96"></div> */}
      </div>
      <div className="mx-6">
        <Tabs
          options={NftApiPageMenus.map((o) => ({
            label: o.label,
            url: o.url,
            testId: o.testId,
          }))}
        />
        <div className="py-6">
          <Outlet />
        </div>
      </div>
    </>
  );
};
export default NftApiPage;
